/** Whole seconds remaining until a signed check-in pass expires. */
export function getCheckinPassSecondsRemaining(
  expiresAt: string,
  now = Date.now(),
): number {
  const milliseconds = new Date(expiresAt).getTime() - now;
  return Number.isFinite(milliseconds)
    ? Math.max(0, Math.ceil(milliseconds / 1000))
    : 0;
}

/** Format whole seconds as mm:ss (90 → "01:30"). */
export function formatCheckinPassCountdown(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(seconds / 60);
  return `${String(minutes).padStart(2, "0")}:${String(seconds % 60).padStart(2, "0")}`;
}
